var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.selected,"placeholder":_vm.plc || _vm.$t('message.product'),"filterable":"","clearable":""},on:{"input":_vm.dispatch}},_vm._l((_vm.products),function(product){return _c('el-option',{key:product.id,attrs:{"label":_vm.formatProductOption(product),"value":product.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }